"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
exports.__esModule = true;
exports.getQuotedIdentifier = exports.getComment = exports.createResult = void 0;
var types_1 = require("../types");
var const_1 = require("./const");
var createResult = function (name, value, remainingString) { return ({
    token: __assign({ name: name }, (value !== null ? { value: value } : {})),
    remainingString: remainingString
}); };
exports.createResult = createResult;
var getComment = function (expression) {
    var tokenEnd = expression.length;
    for (var i = 0; i < expression.length; i += 1) {
        var letter = expression[i];
        if (letter === const_1.EOL) {
            tokenEnd = i;
            break;
        }
    }
    return (0, exports.createResult)(types_1.Tokens.COMMENT, expression.slice(0, tokenEnd), expression.slice(tokenEnd + 1));
};
exports.getComment = getComment;
var getQuotedIdentifier = function (expression) {
    var escapeQuotation = false;
    var value = '';
    var tokenEnd = null;
    for (var i = 0; i < expression.length; i += 1) {
        var char = expression[i];
        if (tokenEnd === null) {
            if (char === const_1.QUOTED_IDENTIFIER_DELIMITER) {
                if (escapeQuotation) {
                    value = value.slice(0, -1) + const_1.QUOTED_IDENTIFIER_DELIMITER;
                    escapeQuotation = false;
                }
                else {
                    tokenEnd = i;
                }
            }
            else {
                if (char === const_1.ESCAPE_CHARACTER) {
                    escapeQuotation = true;
                }
                else {
                    escapeQuotation = false;
                }
                value = value += char;
            }
        }
        else {
            if (!const_1.SEPARATORS.has(char) && !const_1.STRUCTURAL_CHARACTERS[char]) {
                throw new Error("Unexpected character: ".concat(char, " Expected ) character or separator"));
            }
            break;
        }
    }
    if (tokenEnd === null) {
        throw new Error("Unexpected end of expression: expected ".concat(const_1.QUOTED_IDENTIFIER_DELIMITER, " character"));
    }
    return (0, exports.createResult)(types_1.Tokens.IDENTIFIER, value, expression.slice(tokenEnd + 1));
};
exports.getQuotedIdentifier = getQuotedIdentifier;
